import React, { FC } from "react";
import ShopLayout1 from "components/layouts/ShopLayout1";
import { promotionalsFlag } from "common/constants/feature-toggles";
import PageDisableComponent from "components/PageDisabled";
import { Container } from "@mui/material";
import { H1 } from "components/Typography";
import { useIsMobile } from "hooks";
import PromotionalSection from "./components/PromotionalSection";

const PromotionalListPage: FC = () => {
  const isMobile = useIsMobile();

  if (!promotionalsFlag) {
    return <PageDisableComponent />;
  }

  return (
    <ShopLayout1 title="Promotionals">
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          rowGap: "1.5em",
          mb: isMobile ? "1em" : "10em",
        }}
      >
        <H1 style={{ marginTop: ".8em", fontSize: isMobile ? "1em" : "2.5em" }}>
          Bundles and Promos
        </H1>
        <PromotionalSection />
      </Container>
    </ShopLayout1>
  );
};

export default PromotionalListPage;
